import React from 'react';

type MultilineTextboxProps = {
    label: string;
    value: string;
    placeholder: string;
    id: string;
    required?: boolean;
    disabled?:boolean;
    width?:string;
    onChange: (id:string,newvalue:string,oldvalue:string|null) => void;
};

const MultilineTextbox: React.FC<MultilineTextboxProps> = ({
    label,
    value,
    placeholder,
    id,
    required,
    disabled,
    width,
    onChange,
}) => {
    return (
        <div className="form-floating form-floating-txt mb-3" style={{minWidth:width?width:'820px'}}>
            <textarea className="form-control" placeholder={placeholder} id={id} style={{height:'100px', resize:'none', maxHeight:'100px'}} value={value} required={required} disabled={disabled} onChange={(event)=>onChange(id,event.target.value,value)}></textarea>
            <label htmlFor={id}>{required?label+'*':label}</label>
            <div className="invalid-feedback">
                Please provide a valid city.
            </div>
        </div>
    );
};

export default MultilineTextbox;
